import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SmartyStreetsFloatingField from 'components/essentials/SmartyStreetsFloatingField';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import TwoColumnFormFields from 'components/consumer/TwoColumnFormFields';
import ZipField from '../../../Shipping/components/ZipField';
import CityField from '../../../Shipping/components/CityField';
import StateField from '../../../Shipping/components/StateField';
import ApartmentField from '../../../Shipping/components/ApartmentField';
import PhoneNumberField from '../../../Shipping/components/PhoneNumberField';
const BillingAddressFields = t0 => {
  const $ = _c(81);
  const {
    apartmentFieldPlaceholder,
    errors,
    handleBlur,
    handleChange,
    id,
    isRequired,
    setFieldTouched,
    setFieldValue,
    touched,
    values,
    variant
  } = t0;
  const addressRef = useRef();
  const t1 = variant === "ConvertToOrderModalUI";
  let t2;
  if ($[0] !== t1) {
    t2 = classNames("billing-address-section [border-top:1px_solid_#e5e5e5] mt-8 pt-8", {
      "mt-4 pt-4": t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${id}.address`;
  const t4 = `${id}.address`;
  const t5 = `${id}.state`;
  const t6 = `${id}.city`;
  const t7 = `${id}.zipcode`;
  const t8 = `${id}.address`;
  let t9;
  if ($[2] !== errors.address || $[3] !== handleBlur || $[4] !== handleChange || $[5] !== isRequired || $[6] !== setFieldValue || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8 || $[13] !== touched.address || $[14] !== values.address) {
    t9 = <SmartyStreetsFloatingField showError={true} id={t3} refField={addressRef} name={t4} error={errors.address} value={values.address} isRequired={isRequired} handleBlur={handleBlur} handleChange={handleChange} isTouched={touched.address} setFieldValue={setFieldValue} stateFieldName={t5} cityFieldName={t6} zipCodeFieldName={t7} addressFieldName={t8} />;
    $[2] = errors.address;
    $[3] = handleBlur;
    $[4] = handleChange;
    $[5] = isRequired;
    $[6] = setFieldValue;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = touched.address;
    $[14] = values.address;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `${id}.city`;
  const t11 = `${id}.city`;
  let t12;
  if ($[16] !== errors.city || $[17] !== handleBlur || $[18] !== handleChange || $[19] !== isRequired || $[20] !== t10 || $[21] !== t11 || $[22] !== touched.city || $[23] !== values.city) {
    t12 = <CityField id={t10} name={t11} value={values.city} error={errors.city} isTouched={touched.city} handleBlur={handleBlur} handleChange={handleChange} isRequired={isRequired} />;
    $[16] = errors.city;
    $[17] = handleBlur;
    $[18] = handleChange;
    $[19] = isRequired;
    $[20] = t10;
    $[21] = t11;
    $[22] = touched.city;
    $[23] = values.city;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = `${id}.apartment`;
  const t14 = `${id}.apartment`;
  let t15;
  if ($[25] !== apartmentFieldPlaceholder || $[26] !== errors.apartment || $[27] !== handleBlur || $[28] !== handleChange || $[29] !== t13 || $[30] !== t14 || $[31] !== touched.apartment || $[32] !== values.apartment) {
    t15 = <ApartmentField id={t13} name={t14} value={values.apartment} error={errors.apartment} handleBlur={handleBlur} handleChange={handleChange} isTouched={touched.apartment} placeholder={apartmentFieldPlaceholder} />;
    $[25] = apartmentFieldPlaceholder;
    $[26] = errors.apartment;
    $[27] = handleBlur;
    $[28] = handleChange;
    $[29] = t13;
    $[30] = t14;
    $[31] = touched.apartment;
    $[32] = values.apartment;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = `${id}.company`;
  const t17 = `${id}.company`;
  let t18;
  if ($[34] !== handleBlur || $[35] !== handleChange || $[36] !== t16 || $[37] !== t17 || $[38] !== values.company) {
    t18 = <LabeledTextInput id={t16} type="text" name={t17} label="Company (optional)" onChange={handleChange} onBlur={handleBlur} value={values.company} autoComplete="organization" data-xc="shipping-company-field" />;
    $[34] = handleBlur;
    $[35] = handleChange;
    $[36] = t16;
    $[37] = t17;
    $[38] = values.company;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t15 || $[41] !== t18) {
    t19 = <TwoColumnFormFields>{t15}{t18}</TwoColumnFormFields>;
    $[40] = t15;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const t20 = `${id}.state`;
  const t21 = `${id}.state`;
  let t22;
  if ($[43] !== errors.state || $[44] !== handleBlur || $[45] !== isRequired || $[46] !== setFieldTouched || $[47] !== setFieldValue || $[48] !== t20 || $[49] !== t21 || $[50] !== touched.state || $[51] !== values.state) {
    t22 = <StateField id={t20} name={t21} value={values.state} error={errors.state} handleBlur={handleBlur} isTouched={touched.state} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched} isRequired={isRequired} includeAdditionalStates={true} />;
    $[43] = errors.state;
    $[44] = handleBlur;
    $[45] = isRequired;
    $[46] = setFieldTouched;
    $[47] = setFieldValue;
    $[48] = t20;
    $[49] = t21;
    $[50] = touched.state;
    $[51] = values.state;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  const t23 = `${id}.zipcode`;
  const t24 = `${id}.zipcode`;
  let t25;
  if ($[53] !== errors.zipcode || $[54] !== handleBlur || $[55] !== handleChange || $[56] !== isRequired || $[57] !== t23 || $[58] !== t24 || $[59] !== touched.zipcode || $[60] !== values.zipcode) {
    t25 = <ZipField id={t23} name={t24} value={values.zipcode} error={errors.zipcode} handleBlur={handleBlur} isTouched={touched.zipcode} handleChange={handleChange} isRequired={isRequired} />;
    $[53] = errors.zipcode;
    $[54] = handleBlur;
    $[55] = handleChange;
    $[56] = isRequired;
    $[57] = t23;
    $[58] = t24;
    $[59] = touched.zipcode;
    $[60] = values.zipcode;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t22 || $[63] !== t25) {
    t26 = <TwoColumnFormFields>{t22}{t25}</TwoColumnFormFields>;
    $[62] = t22;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  const t27 = `${id}.phone_number`;
  const t28 = `${id}.phone_number`;
  let t29;
  if ($[65] !== errors.phone_number || $[66] !== handleBlur || $[67] !== handleChange || $[68] !== isRequired || $[69] !== t27 || $[70] !== t28 || $[71] !== touched.phone_number || $[72] !== values.phone_number) {
    t29 = <PhoneNumberField id={t27} name={t28} placeholder="Phone" handleBlur={handleBlur} handleChange={handleChange} error={errors.phone_number} value={values.phone_number} isTouched={touched.phone_number} isRequired={isRequired} />;
    $[65] = errors.phone_number;
    $[66] = handleBlur;
    $[67] = handleChange;
    $[68] = isRequired;
    $[69] = t27;
    $[70] = t28;
    $[71] = touched.phone_number;
    $[72] = values.phone_number;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  let t30;
  if ($[74] !== t12 || $[75] !== t19 || $[76] !== t2 || $[77] !== t26 || $[78] !== t29 || $[79] !== t9) {
    t30 = <div className={t2}>{t9}{t12}{t19}{t26}{t29}</div>;
    $[74] = t12;
    $[75] = t19;
    $[76] = t2;
    $[77] = t26;
    $[78] = t29;
    $[79] = t9;
    $[80] = t30;
  } else {
    t30 = $[80];
  }
  return t30;
};
BillingAddressFields.propTypes = {
  apartmentFieldPlaceholder: PropTypes.string,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  touched: PropTypes.object,
  values: PropTypes.object,
  variant: PropTypes.oneOf(['ConvertToOrderModalUI'])
};
export default BillingAddressFields;